import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';

function App() {
  return (
    <Router>
      <Routes>
        {/* Default page is Login */}
        <Route path="/" element={<Login />} />
        
        {/* Registration page */}
        <Route path="/register" element={<Register />} />
        
        {/* Dashboard - eventually you can protect this route */}
        <Route path="/dashboard" element={<Dashboard />} />

        {/* Catch-all: redirect any unknown URL back to login */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;